import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { FaIcon } from '../FaIcon';

class DataExplorerToolbarComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isExportMenuOpen: false,
        };
        this.controlsRef = React.createRef();
        this.handleClickOutside = this.handleClickOutside.bind(this);
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    handleClickOutside(event) {
        if (this.controlsRef.current && !this.controlsRef.current.contains(event.target)) {
            this.setState({ isExportMenuOpen: false });
        }
    }

    render() {
        const { t } = this.props;

        return (
            <div className="data-explorer-toolbar">
                <div className="data-explorer-toolbar__actions" ref={this.controlsRef}>
                    {/* Botón compartir */}
                    <button
                        type="button"
                        className="btn chart-controls__action-button no-margin-bottom"
                        title={t('data_explorer.share_link', 'Compartir enlace')}
                        onClick={this.props.onShareUrl}
                    >
                        <FaIcon iconName="link" />
                    </button>

                    {/* Botón descarga con dropdown */}
                    <button
                        type="button"
                        className="btn chart-controls__action-button no-margin-bottom"
                        title={t('data_explorer.export', 'Exportar')}
                        onClick={() => this.setState({ isExportMenuOpen: !this.state.isExportMenuOpen })}
                    >
                        <FaIcon iconName="download" />
                    </button>

                    {this.state.isExportMenuOpen && (
                        <div className="chart-controls__adjust-menu">
                            <div className="chart-controls__adjust-menu-title">
                                {t('data_explorer.export', 'Exportar')}
                            </div>
                            <div
                                onClick={() => {
                                    if (this.props.onDownloadPDF) this.props.onDownloadPDF();
                                    this.setState({ isExportMenuOpen: false });
                                }}
                                className="chart-controls__adjust-menu-option"
                            >
                                {t('data_explorer.export_to_pdf', 'Descargar como PDF')}
                            </div>
                            <div
                                onClick={() => {
                                    if (this.props.onDownloadCSV) this.props.onDownloadCSV();
                                    this.setState({ isExportMenuOpen: false });
                                }}
                                className="chart-controls__adjust-menu-option"
                            >
                                {t('data_explorer.export_to_csv', 'Exportar a archivo CSV')}
                            </div>
                            <div
                                onClick={() => {
                                    if (this.props.onExportDataNodeJson) this.props.onExportDataNodeJson();
                                    this.setState({ isExportMenuOpen: false });
                                }}
                                className="chart-controls__adjust-menu-option"
                            >
                                {t('data_explorer.export_data_node_json', 'JSON para Nodo de datos')}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

export const DataExplorerToolbar = withTranslation()(DataExplorerToolbarComponent);
